import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Início', href: '#hero' },
    { label: 'Sobre nós', href: '#filosofia' },
    { label: 'Cursos', href: '#cursos' },
    { label: 'Depoimentos', href: '#depoimentos' },
    { label: 'Contato', href: '#contato' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-white shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-12 lg:px-16">
        <div className="flex items-center justify-between h-[72px]">
          <a href="#hero" className="flex items-center gap-3 group">
            <img
              src="https://storage.readdy-site.link/project_files/10dd6ff9-efe2-4505-9f10-13a932b2db17/bbccb5ae-0ca2-471a-a66e-ca9ecbb67a44_compressed_TL.webp"
              alt="TL Artes & Música"
              className={`h-9 w-auto object-contain transition-all duration-500 ${
                scrolled ? 'brightness-0' : ''
              }`}
            />
          </a>

          <div className="hidden md:flex items-center gap-10">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`font-sans text-[13px] font-medium tracking-wider uppercase whitespace-nowrap transition-colors duration-300 hover:opacity-70 ${
                  scrolled ? 'text-night-blue' : 'text-white'
                }`}
              >
                {link.label}
              </a>
            ))}
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center transition-colors duration-500 ${
              scrolled ? 'text-night-blue' : 'text-white'
            }`}
            aria-label="Menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white">
          <div className="px-6 py-6 flex flex-col gap-5">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMobileOpen(false)}
                className="font-sans text-sm font-medium text-night-blue tracking-wider uppercase whitespace-nowrap hover:text-vibrant-blue transition-colors"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}